import BaseModel from '../BaseModel';
import { logType } from '../../../enums';

export default class OfficeInterviewLog extends BaseModel {
  static entity = 'officeInterviewLogs';

  static primaryKey = 'id';

  static fields() {
    return {
      id: this.attr(null),
      officeInterviewId: this.attr(null),
      comment: this.string(null).nullable(),
      timestamp: this.number(null).nullable(),
      createdAt: this.string(null).nullable(),
      type: this.string(logType.OFFICE_INTERVIEW),
      eventType: this.string(logType.ONLINE_INTERVIEW),
    };
  }

  static apiConfig = {
    actions: {
      fetchAllByOfficeInterviewId(id, key = null) {
        return this.model.handleFetching(
          () => this.get(`office-interviews/${id}/logs`),
          key || `all_by_office_interview_${id}`,
        );
      },
      store(officeInterviewId, payload) {
        return this.post(`office-interviews/${officeInterviewId}/logs`, payload);
      },
      destroy(officeInterviewLogId) {
        return this.delete(
          `office-interviews/logs/${officeInterviewLogId}`,
          { delete: officeInterviewLogId },
        );
      },
    },
  }
}
